// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1hTMJ","approved":"Status_approved__HweTL","rejected":"Status_rejected__1cMbN","expired":"Status_expired__3I5tK","label":"Status_label__2K5_V"};